export default {
  promotional_text: 'Poupe tempo e ganhe recompensas!',
  description:
    'A App {{name}} chegou – para encomendas ainda mais fáceis:\n\n• Encomendas super rápidas via app\n\n• Notificações imediatas sobre promoções e recompensas\n\n• Acumule e utilize os seus pontos facilmente\n\n• Acompanhe o estado da sua encomenda em tempo real\n\nTemos o prazer de lhe oferecer a nossa app – e esperamos que se divirta tanto com ela como nós!\\`',
  keywords:
    'Encomenda Móvel, App de Restaurante, App de Comida, Takeaway, Encomendar Comida, Takeaway, Serviço de Entrega',
};
